import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { TipoEspacioI } from "interfaces/TipoEspacio";
import { Dropdown } from "react-bootstrap";
import { deleteTipoEspacio } from "services/tipoEspacio";

interface Props {
  elemento: TipoEspacioI;
  onClickEdit: (elemento: TipoEspacioI) => void;
  refreshTable: () => void;
}

export const TipoEspacioRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteTipoEspacio(id);
      showSuccessToast("¡El tipo de espacio fue eliminado con éxito!");
      refreshTable();
    } catch (error) {
      showErrorToast("Error eliminando el tipo de espacio");
    }
  };

  // const onClickVerDocumento = (id: string | number) => {
  //     openFile({ id })
  // }

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar resolución"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el Tipo de espacio {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
